import VueRouter from 'vue-router'
const Home = ()=> import('@/pages/Home')
const About = ()=> import('@/pages/About')
const News = ()=> import('@/pages/News')
const NewsDet = ()=> import('@/pages/News/detail.vue')
const Download = ()=>  import('@/pages/Download')
const Innovation = ()=> import('@/pages/Innovation')
const Product = () => import('@/pages/Product')
const Module = () => import('@/pages/Product/module.vue')
const Dealer = () => import('@/pages/Product/dealer.vue')
const Solution = () => import('@/pages/Solution')
const Case = () => import('@/pages/Case')
const Sustain = () => import('@/pages/Sustain')

export default new VueRouter({
    mode:'history',
    routes:[
        {
            path: '/es',
            component: Home
        },
        {
            path: '/es/about',
            component: About
        },
        {   
            name:'news',
            path: '/es/news/:p?',
            component: News,
            props({query}){
                return { p:query.p }
            }
        },
        {
            path: '/es/newsdet',
            component: NewsDet,
            props({query}){
                return { id:query.id }
            }
        },
        {
            name:'load',
            path: '/es/download',
            component: Download,
            props({query}){
                return { pid:query.pid, cid:query.cid, p:query.p }
            }
        },
        {
            path: '/es/innovation',
            component: Innovation
        },
        {
            path: '/es/product',
            component: Product,
            props({query}){
                return { id:query.id }
            }
        },
        {
            path:'/es/module',
            component: Module,
        },
        {
            path:'/es/dealer',
            component: Dealer,
        },
        {
            path: '/es/solution',
            component: Solution,
            props({query}){
                return{ id:query.id }
            }
        },{
            name:'case',
            path:'/es/case',
            component: Case,
            props({query}){
                return { p:query.p }
            }
        },
        {
            path:'/es/sustainability',
            component: Sustain
        }
    ]
})